import { AbstractRepository } from '@/repositories/abstract-repository';
import { TemplateTag } from '@/communications/templates/models/template-tag';

export class TemplateTagsRepository extends AbstractRepository<TemplateTag> {
    readonly endpoint = 'types/template-tags';

    public async getAllTags(): Promise<Array<TemplateTag>> {
        return (await this.getAll()).entities;
    }
}
